<main id="main-content" class="h-screen flex flex-col p-4 transition-all duration-0">
  <div class="w-full flex flex-col p-2 items-center gap-2">
    <div class="w-full flex items-center justify-between gap-4">
      <div class="oswald-font flex items-center justify-center gap-2">
        <img src="assets/nside-tips-logo.png" alt="nSide Tips Logo" class="w-44">
        <h1 class="text-3xl uppercase">
          Dashboard
        </h1>
      </div>
      <div class="flex items-center justify-center gap-2">
        <p class="text-2xl oswald-font font-medium">Submit a Tip:</p>
        <a [href]="publicTipUrl" target="_blank"
          class="h-10 bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 text-white flex items-center justify-center align-middle px-4 rounded-md hover:from-nside-gray-100 hover:to-nside-gray-200">
          Public Link
        </a>
        <a [href]="schoolTipUrl" target="_blank"
          class="h-10 bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 text-white flex items-center justify-center align-middle px-4 rounded-md hover:from-nside-gray-100 hover:to-nside-gray-200">
          School Link
        </a>
        <tip-assistant></tip-assistant>
      </div>
    </div>
  </div>

  <!-- MAIN CONTENT -->
  <div class=" p-2 w-full flex flex-grow flex-col items-start overflow-y-auto">
    <div class="w-full max-h-full bg-white rounded-b-md rounded-tr-md shadow-custom-2 p-6 overflow-y-auto">
      <div class="h-full w-full flex flex-col gap-4">
        <div class="w-full flex items-center justify-center gap-4">

          <div class="w-32 h-full">
            <button id="statusDropdownButton" data-dropdown-toggle="statusDropdown"
              class="flex items-center justify-center gap-2 w-full h-full rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 text-white"
              type="button">
              {{ statusFilterLabel }}
              <svg class="w-2.5 h-2.5 ms-3" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m1 1 4 4 4-4" />
              </svg>
            </button>
            <!-- Dropdown menu -->
            <div id="statusDropdown" class="z-10 hidden divide-y divide-gray-300 bg-orange-50 rounded-md w-32">
              <ul class="py-2" aria-labelledby="statusDropdownButton">
                <li>
                  <a href="#" 
                     class="block px-4 py-2 hover:bg-white hover:text-nside-orange-400"
                     (click)="onStatusFilterChange(''); $event.preventDefault();">
                    All Statuses
                  </a>
                </li>
                <li>
                  <a href="#" 
                     class="block px-4 py-2 hover:bg-white hover:text-nside-orange-400"
                     (click)="onStatusFilterChange('0'); $event.preventDefault();">
                    Open
                  </a>
                </li>
                <li>
                  <a href="#" 
                     class="block px-4 py-2 hover:bg-white hover:text-nside-orange-400"
                     (click)="onStatusFilterChange('1'); $event.preventDefault();">
                    In Review
                  </a>
                </li>
                <li>
                  <a href="#" 
                     class="block px-4 py-2 hover:bg-white hover:text-nside-orange-400"
                     (click)="onStatusFilterChange('2'); $event.preventDefault();">
                    Closed
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="grow relative">
            <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-search-icon lucide-search">
                <path d="m21 21-4.34-4.34" />
                <circle cx="11" cy="11" r="8" />
              </svg>
            </div>
            <input 
              type="search" 
              id="tipSearchInput"
              class="block w-full p-2 ps-10 text-sm border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
              [(ngModel)]="searchQuery" 
              (input)="filterTipsList()"
              placeholder="Search Tips..." 
            />
          </div>

        </div>
        <div class="w-full h-full overflow-y-auto">      
          <ng-container *ngIf="filteredTipsList.length > 0; else emptyTipsList">
            <table class="w-full text-left">
              <thead class="oswald-font w-full text-gray-700 uppercase bg-main-background">
                <tr class="w-full">
                  <th scope="col" class="px-4 py-3 w-14">
                    <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                      No.
                    </div>
                  </th>
                  <th scope="col" class="px-4 py-3 w-48 min-w-32">
                    <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap"
                      onclick="toggleSortByDate()" id="submittedHeader">
                      Submitted
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-arrow-up-down-icon lucide-arrow-up-down">
                        <path d="m21 16-4 4-4-4" />
                        <path d="M17 20V4" />
                        <path d="m3 8 4-4 4 4" />
                        <path d="M7 4v16" />
                      </svg>
                    </div>
                  </th>
                  <th scope="col" class="px-4 py-3 min-w-96">
                    <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                      Summary
                    </div>
                  </th>
                  <th scope="col" class="px-4 py-3 w-28">
                    <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                      Status
                    </div>
                  </th>
                  <th scope="col" class="px-4 py-3 w-48 min-w-40">
                    <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                      Full Name
                    </div>
                  </th>
                  <th scope="col" class="px-4 py-3 w-48 min-w-40">
                    <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                      Email
                    </div>
                  </th>
                  <th scope="col" class="px-4 py-3 w-48 min-w-40">
                    <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                      Phone
                    </div>
                  </th>
                  <th scope="col" class="px-4 py-3 w-40 min-w-32">
                    <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                      Actions
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let tip of filteredTipsList | paginate: { itemsPerPage: itemsPerPage, currentPage: page }; let i = index;" class="bg-white border-b">
                  <th scope="row" class="px-4 py-4">
                    {{ i + 1 + (page - 1) * itemsPerPage }}
                  </th>
                  <td class="px-4 py-4 font-medium text-gray-900 whitespace-nowrap">
                    {{ tip.submission_date | date: 'MM/dd/yyyy - HH:mm' }}
                  </td>
                  <td class="px-4 py-4 whitespace-pre-line break-all">
                    <span>
                      {{ 
                        expandedTipIndex === i 
                          ? tip.tip_summary 
                          : (tip.tip_summary | slice:0:100) + (tip.tip_summary.length > 100 ? '...' : '') 
                      }}
                    </span>
                    <button 
                      *ngIf="tip.tip_summary.length > 100" 
                      class="text-blue-500 underline ml-2"
                      (click)="toggleShowMore(i)">
                      {{ expandedTipIndex === i ? 'Show less' : 'Show more' }}
                    </button>
                  </td>
                  <td class="px-4 py-4">
                    <div *ngIf="tip.status == 0">
                      <button 
                        [attr.data-tooltip-target]="'tooltip-status-' + tip.id"  data-tooltip-placement="bottom"
                        class="w-7 h-7 flex items-center justify-center"
                      >
                      <img src="assets/tip-open.png" alt="nSide Tips Logo" class="">
                      </button>
                      <div [id]="'tooltip-status-' + tip.id" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        Open
                        <div class="tooltip-arrow" data-popper-arrow></div>
                      </div>
                    </div>
                    <div *ngIf="tip.status == 1">
                      <button 
                        [attr.data-tooltip-target]="'tooltip-status-' + tip.id"  data-tooltip-placement="bottom"
                        class="w-7 h-7 flex items-center justify-center"
                      >
                        <img src="assets/tip-in-review.png" alt="nSide Tips Logo" class="">
                      </button>
                      <div [id]="'tooltip-status-' + tip.id" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        In Review
                        <div class="tooltip-arrow" data-popper-arrow></div>
                      </div>
                    </div>
                    <div *ngIf="tip.status == 2">
                      <button 
                        [attr.data-tooltip-target]="'tooltip-status-' + tip.id"  data-tooltip-placement="bottom"
                        class="w-7 h-7 flex items-center justify-center"
                      >
                        <img src="assets/tip-closed.png" alt="nSide Tips Logo" class="">
                      </button>
                      <div [id]="'tooltip-status-' + tip.id" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        Closed
                        <div class="tooltip-arrow" data-popper-arrow></div>
                      </div>
                    </div>
                  </td>
                  <td class="px-4 py-4">{{ tip.full_name }}</td>
                  <td class="px-4 py-4">{{ tip.email }}</td>
                  <td class="px-4 py-4">{{ tip.phone }}</td>
                  <td class="px-4 py-4">
                    <div class="flex items-center justify-start gap-1">
                      <button 
                        [attr.data-tooltip-target]="'tooltip-manage-' + tip.id"  data-tooltip-placement="bottom"
                        class="w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center hover:text-white hover:bg-nside-gray-200"
                        (click)="$event.preventDefault(); handleOpenModal('manage', tip);"
                      >
                        <lucide-icon [img]="icons.Pencil" size="20"></lucide-icon>
                      </button>
                      <div [id]="'tooltip-manage-' + tip.id" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        Manage
                        <div class="tooltip-arrow" data-popper-arrow></div>
                      </div>
                      <button 
                        *ngIf="tip.status == 1 && hasAssess === '1' && userAssessPermission === '1'"
                        [attr.data-tooltip-target]="'tooltip-assess-' + tip.id"  data-tooltip-placement="bottom"
                        class="w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center hover:text-white hover:bg-nside-gray-200"
                        (click)="$event.preventDefault(); handleOpenModal('createAssess', tip);"
                      >
                        <lucide-icon [img]="icons.BookA" size="20"></lucide-icon>
                      </button>
                      <div [id]="'tooltip-assess-' + tip.id" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        Create Assess Case
                        <div class="tooltip-arrow" data-popper-arrow></div>
                      </div>
                      <button 
                        [attr.data-tooltip-target]="'tooltip-history-' + tip.id"  data-tooltip-placement="bottom"
                        class="w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center hover:text-white hover:bg-nside-gray-200"
                        (click)="$event.preventDefault(); handleOpenModal('history', tip);"
                      >
                        <lucide-icon [img]="icons.History" size="20"></lucide-icon>
                      </button>
                      <div [id]="'tooltip-history-' + tip.id" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        History
                        <div class="tooltip-arrow" data-popper-arrow></div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-container>

          <ng-template #emptyTipsList>
            <div class="w-full text-nside-gray-100 italic">
              Empty Tip
            </div>
          </ng-template>
        </div>
        <div class="flex justify-between items-center">
            <p>{{ filteredTipsList.length }} in total</p>
            <pagination-controls
                *ngIf="filteredTipsList.length > itemsPerPage"
                (pageChange)="page = $event"
                previousLabel="Prev"
                nextLabel="Next"
                class="mt-2"
            ></pagination-controls>
        </div>
      </div>
    </div>
  </div>

  <manage-tip
    *ngIf="this.showManage && this.currentTip"
    [tip]="this.currentTip"
    (onClose)="handleCloseModal('manage')"
    (onSave)="handleSaveTip($event, 'manage')"
  ></manage-tip>

  <create-assess-case
    *ngIf="this.showCreateAssess && this.currentTip"
    [tip]="this.currentTip"
    (onClose)="handleCloseModal('createAssess')"
    (onSave)="handleSubmitStudentSSID($event)"
  ></create-assess-case>
  
  <student-info-form
    *ngIf="this.showStudentInfoForm && this.studentSSID"
    [ssidNum]="this.studentSSID"
    (onClose)="handleCloseModal('student info')"
    (onSave)="handleCreateStudent($event)"
  ></student-info-form>

  <student-info-review
    *ngIf="this.showStudentInfoReview && this.currentStudent"
    [studentInfo]="this.currentStudent"
    (onClose)="handleCloseModal('student info review')"
    (onContinue)="handleCloseModal('student info review and continue')"
  ></student-info-review>

  <student-cases
    *ngIf="this.showStudentCases && this.currentStudent"
    [ssidNum]="this.currentStudent.student_identifier"
    (onClose)="handleCloseModal('student cases')"
    (onSubmit)="handleCreateNewCaseForExistingStudent($event)"
  ></student-cases>

  <history
    *ngIf="this.showHistory && this.currentTip"
    [tipId]="this.currentTip.id"
    (onClose)="handleCloseModal('history')"
  ></history>

  <popup-message 
    [type]="messageModal" 
    (close)="resetMessageModal()" 
    [message]="popupMessage"
  ></popup-message>

  <div *ngIf="loading">
    <spinner></spinner>
  </div>

</main>